document.addEventListener("DOMContentLoaded", function () {
    var buttons = document.querySelectorAll("#section-employment .show_hide");

    buttons.forEach(function (button) {
        button.addEventListener("click", function () {
            console.log("Button clicked:", button.textContent);

            if (button.textContent == "see our benefits") {
                button.textContent = "see less";
            } else {
                button.textContent = "see our benefits";
            }

            var dataOrder = this.getAttribute("data-order");
            var containerId = "list-services-" + dataOrder;
            var container = document.getElementById(containerId);

            if (container) {
                container.classList.toggle("open");
            }
        });
    });
});
